import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import flow from "lodash/fp/flow";
import constants from "../../core/constants";

class CompaniesPageTransform {
  constructor() {
    "ngInject";

    // NOTE: name is used for (user roles)
    this.item = {
      title: "Company",
      state: "company",
      name: "company",
    };

    this.fields = [
      { title: "Name", name: "name", isSortable: true },
      { title: "City", name: "city" },
    ];

    this.filters = [
      {
        name: "search",
        title: "Search",
        icon: "search",
        isSearch: true,
        resource: "Company",
        state: "company",
        size: 25,
      },
    ];

    this.addOptions = {
      title: "Add New Company",
      icon: "add",
      fields: [
        {
          resource: "City",
          name: "city",
          title: "City",
          isResource: true,
          isRequired: true,
        },
        {
          name: "name_i18n",
          title: "Company’s Name",
          type: "text",
          isI18nText: true,
          isRequired: true,
        },
        {
          name: "phone_data",
          title: "Company Phone Number",
          type: "number",
          isPhoneObject: true,
          isRequired: true,
          pattern: constants.RegExp.phone,
          patternErrorMsg: "Company Phone Number must be at least 10 digits",
        },
        {
          name: "owner_name",
          title: "Owner's Name",
          isI18nText: true,
          isRequired: true,
        },
        {
          name: "owner_phone_data",
          title: "Owner's Contact Number",
          type: "number",
          isPhoneObject: true,
          isRequired: true,
          pattern: constants.RegExp.phone,
          patternErrorMsg: "Owner's Contact Number must be at least 10 digits",
        },
        {
          name: "email",
          title: "Owner's Email",
          type: "email",
          isText: true,
          isRequired: true,
          pattern: constants.RegExp.email,
          patternErrorMsg: "This is not a valid email address",
        },
        {
          name: "is_tax_filer",
          title: "Tax Filer",
          value: null,
          list: "taxFilers",
          isRequired: false,
        },
        {
          name: "show_ride_price",
          title: "Show Ride Price",
          isCheckBox: true,
          default: true,
        },
      ],
    };
  }

  justify(data) {
    const getSource = (item) => assign({ _id: item._id }, item._source);

    const format = (item) => {
      item.name = item.name_i18n.en;
      item.city = item.city.name;

      return item;
    };

    return map(flow([getSource, format]))(data);
  }
}

export default CompaniesPageTransform;



// WEBPACK FOOTER //
// ./src/pages/companies/companies.transforms.js